import React from 'react';
import styles from './Middle.module.css'; // Import the module CSS
import model_icon from '../../static_files/YZY_background.png'; // Example import

const YZYLaunch = () => {
    return (

        <section className={styles['yzy-launch-container']} id="More">
            <img
                src={model_icon}
                alt="YZY Signature"
                style={{cursor: 'pointer'}}
                onClick={() => window.open('https://yeezy.com/', '_blank')}
            />
             <div className={styles['yzy-text-container']}>
            <div className={styles['yzy-launch-header']}>
                <h2>YZY: The Next-Gen Coin</h2>
            </div>

            {/* Main content section */}
            <div className={styles['yzy-launch-content']}>
                {/* “Poster” style card */}


                {/* Optionally insert a stylized signature or graphic */}


                {/* Copy block about the coin */}
                <div className={styles['yzy-launch-text']}>
                    <p>
                        On <strong>April 7, 2025</strong>, the future of fashion-forward crypto commerce
                        arrives with YZY coin. Designed from the ground up to power trading and shopping
                        experiences on <strong
                        onClick={() => window.open('https://yeezy.com', '_blank')}
                        style={{cursor: 'pointer'}}
                    >
                        Yeezy.com
                    </strong>,
                        $YZY combines cutting-edge blockchain technology
                        with the unmistakable flair of the Yeezy brand.
                    </p>

                </div>
            </div>
            </div>

        </section>
    );
};

export default YZYLaunch;